import { motion, AnimatePresence } from "framer-motion"

import VERTESIA_ICON from "@/assets/vertesia-icon.png"
import STACKED_VERTESIA_ICON from "@/assets/vertesia-stacked.png"
import { NavigationSection } from "@/components/navigation/NavigationSection"
import { Sidebar, SidebarContent, SidebarFooter, useSidebar } from "@ui/sidebar"
import { APPLICATION_SECTION, ADVANCED_SECTION } from "@/constants/navigation"

export function ApplicationSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { state } = useSidebar()
    const isExpanded = state === "expanded"

    return (
        <Sidebar
            collapsible="icon"
            className="top-[var(--header-height)] !h-[calc(100svh-var(--header-height))] border-gray-300"
            {...props}
        >
            <SidebarContent>
                <NavigationSection section={APPLICATION_SECTION} />
                <NavigationSection section={ADVANCED_SECTION} />
            </SidebarContent>
            <SidebarFooter>
                <div className="flex items-end justify-center w-full h-[60px] relative">
                    <AnimatePresence mode="wait">
                        {
                            isExpanded ? (
                                <motion.img
                                    key="stacked"
                                    src={STACKED_VERTESIA_ICON}
                                    alt="Vertesia logo"
                                    initial={{ opacity: 0, scale: 0.8, width: 40 }}
                                    animate={{ opacity: 1, scale: 1, width: 130 }}
                                    exit={{ opacity: 0, scale: 0.8 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="absolute"
                                    style={{ width: 130 }}
                                />
                            ) : (
                                <motion.img
                                    key="icon"
                                    src={VERTESIA_ICON}
                                    alt="Vertesia logo"
                                    initial={{ opacity: 0, scale: 0.8, width: 130 }}
                                    animate={{ opacity: 1, scale: 1, width: 40 }}
                                    exit={{ opacity: 0, scale: 0.8 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="absolute"
                                    style={{ width: 40 }}
                                />
                            )
                        }
                    </AnimatePresence>
                </div>
            </SidebarFooter>
        </Sidebar>
    )
}